// @ts-strict-ignore
import wsmLogoLight from "@assets/images/map-bg.webp";
import { BadgeCheckIcon, CheckCircle, Star } from "lucide-react";
import React from "react";

import AddOnCard from "./AddOnCard";
import Card from "./Card";

const AddOnsShowcase: React.FC = () => {
  return (
    <Card>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 32 }}>
        <div style={{ fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
          Take your Ecommerce to the next level 🚀
        </div>
        <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1 }}>
          Value added services
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        {/* Left hero card */}
        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            overflow: "hidden",
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            {/* Hero header with gradient */}
            <div
              style={{
                padding: 32,
                height: 192,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                color: "#fff",
                position: "relative",
              }}
            >
              <img
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  
                }}
                src={wsmLogoLight}
                
                alt=""
              />
              <div
                style={{
                  background:
                    "linear-gradient(120deg, rgba(48,46,189,1) 0%, rgba(48,46,189,1) 30%, rgba(74,29,150,0.2) 100%)",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0.9,
                  
                }}
              ></div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  zIndex: 1,
                }}
              >
                <div style={{ display: "grid", gap: 12 }}>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      background: "#fff",
                      color: "#000",
                      borderRadius: 999,
                      paddingLeft: 4,
                      paddingRight: 12,
                      paddingTop: 4,
                      paddingBottom: 4,
                      fontSize: 14,
                      fontWeight: 600,
                      letterSpacing: "0.7px",
                      textTransform: "uppercase",
                      width: "fit-content",
                      lineHeight: 1,
                    }}
                  >
                    <BadgeCheckIcon size={16} /> Guaranteed Top 3 Local Ranking
                  </div>
                  <div style={{ fontSize: 40, fontWeight: 700, lineHeight: 1 }}>WSM Hyperlocal</div>
                  <div style={{ fontSize: 24, fontWeight: 700, lineHeight: 1 }}>$199/mo</div>
                </div>
                <button
                  title="Save"
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    border: "none",
                    borderRadius: 10,
                    width: 40,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    padding: 8,
                    cursor: "pointer",
                  }}
                >
                  <Star size={18} color="#fff" />
                </button>
              </div>
            </div>

            {/* Feature list + CTA */}

            <ul
              style={{
                listStyle: "none",
                display: "flex",
                flexDirection: "column",
                gap: 20,
                padding: 24,
              }}
            >
              <li style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ paddingTop: 6, flexShrink: 0 }}>
                  <CheckCircle size={16} color="#000" opacity={0.7} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={{ fontWeight: 700, opacity: 0.7, fontSize: 18, lineHeight: 1.5 }}>
                    Boost Your Google Maps Ranking
                  </div>
                  <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1.5 }}>
                    Guaranteed visibility in the top 3 local results through real GPS-driven
                    engagement.
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ paddingTop: 6, flexShrink: 0 }}>
                  <CheckCircle size={16} color="#000" opacity={0.7} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={{ fontWeight: 700, opacity: 0.7, fontSize: 18, lineHeight: 1.5 }}>
                    Monthly Review Generation
                  </div>
                  <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1.5 }}>
                    Receive 2–4 authentic, detailed customer reviews each month to strengthen trust
                    and relevance.
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ paddingTop: 6, flexShrink: 0 }}>
                  <CheckCircle size={16} color="#000" opacity={0.7} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={{ fontWeight: 700, opacity: 0.7, fontSize: 18, lineHeight: 1.5 }}>
                    Backlink & SEO Signals
                  </div>
                  <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1.5 }}>
                    Weekly cloud-stack backlinks and ongoing “popularity signal” activity to
                    reinforce local SEO.
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ paddingTop: 6, flexShrink: 0 }}>
                  <CheckCircle size={16} color="#000" opacity={0.7} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={{ fontWeight: 700, opacity: 0.7, fontSize: 18, lineHeight: 1.5 }}>
                    Hands-Free Setup
                  </div>
                  <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1.5 }}>
                    No need to share access to your Google Business Profile or website—everything
                    works externally.
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ paddingTop: 6, flexShrink: 0 }}>
                  <CheckCircle size={16} color="#000" opacity={0.7} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={{ fontWeight: 700, opacity: 0.7, fontSize: 18, lineHeight: 1.5 }}>
                    24/7 Expert Support
                  </div>
                  <div style={{ color: "#000", opacity: 0.6, fontSize: 16, lineHeight: 1.5 }}>
                    Our team is available around the clock to troubleshoot, guide, and maximize your
                    growth.
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div style={{ margin: 24 }}>
            <button
              style={{
                width: "100%",
                padding: "24px",
                borderRadius: 8,
                border: "none",
                background: "#302ebd",
                color: "#fff",

                fontWeight: 800,
                fontSize: 20,
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              Start ranking in the Top 3
            </button>
          </div>
        </div>
        {/* Right column add-ons */}
        <div style={{ display: "grid", gap: 24 }}>
          <AddOnCard
            title="AI receptionist"
            price="$99/mo"
            features={[
              "📞 24/7 AI Receptionist. Always available to greet and assist your customers.",
              "🗓️ Smart Scheduling & Reminders. Capture appointments, send confirmations, and reduce no-shows.",
              "💬 Instant Inquiry Handling. Answer FAQs, collect details, and route leads in real time",
            ]}
            active
          />

          <AddOnCard
            title="AI chatbot"
            price="$75/mo"
            features={[
              "💬 24/7 AI Chatbot. Always available to greet and assist your customers.",
              "🗓️ Smart Scheduling & Reminders. Capture appointments, send confirmations, and reduce no-shows.",
              "💬 Instant Inquiry Handling. Answer FAQs, collect details, and route leads in real time",
            ]}
          />
          <AddOnCard
            title="Add On 4"
            price="$99/mo"
            features={[
              "5 Team Member Licenses",
              "Access to WSM AI",
              "24/7 Expert Support Services",
            ]}
          />
        </div>
      </div>
    </Card>
  );
};

export default AddOnsShowcase;
